// Deutsch — Rückfallsprache. it.ts und en.ts müssen dieselben Schlüssel haben
// (src/test/i18n-keys.test.ts prüft das).

export const de = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    search: "Suchen",
    loading: "Wird geladen …",
    retry: "Erneut versuchen",
    yes: "Ja",
    no: "Nein",
    all: "Alle",
    today: "Heute",
    reason: "Begründung",
    reason_hint: "Wird im Protokoll gespeichert.",
    note: "Notiz",
    from: "Von",
    to: "Bis",
    date: "Datum",
    time: "Uhrzeit",
    status: "Status",
    employee: "Mitarbeiter",
    employees: "Mitarbeiter",
    department: "Abteilung",
    month: "Monat",
    details: "Details",
    saved: "Gespeichert",
    not_set: "—",
    optional: "optional",
    minutes_short: "Min.",
    hours_short: "Std.",
    open: "Öffnen",
    previous: "Zurück",
    next: "Weiter",
  },
  nav: {
    section_overview: "Überblick",
    section_time: "Zeiten",
    section_admin: "Verwaltung",
    today: "Heute",
    employees: "Mitarbeiter",
    times: "Stempelungen",
    accounts: "Zeitkonten",
    absences: "Abwesenheiten",
    payroll: "Monatsabschluss",
    settings: "Einstellungen",
    my_app: "Mitarbeiter-App",
    search: "Suchen …",
    search_placeholder: "Mitarbeiter oder Seite suchen",
    no_results: "Keine Treffer",
    pages: "Seiten",
    theme: "Darstellung",
    theme_light: "Hell",
    theme_dark: "Dunkel",
    theme_system: "System",
    language: "Sprache",
  },
  auth: {
    title: "Anmelden",
    subtitle: "Zeiterfassung und Einsatzplanung",
    email: "E-Mail",
    password: "Passwort",
    sign_in: "Anmelden",
    send_code: "Code per E-Mail senden",
    code: "Code aus der E-Mail",
    code_sent: "Wir haben dir einen 6-stelligen Code geschickt.",
    verify: "Bestätigen",
    use_password: "Mit Passwort anmelden",
    use_code: "Mit Code per E-Mail anmelden",
    sign_out: "Abmelden",
    invalid: "E-Mail oder Passwort stimmen nicht.",
    invalid_code: "Der Code ist ungültig oder abgelaufen.",
    select_tenant: "Betrieb wählen",
    select_tenant_hint: "Du hast Zugang zu mehreren Betrieben. Jeder Browser-Tab arbeitet in einem Betrieb.",
    no_tenant: "Dein Konto ist noch keinem Betrieb zugeordnet. Bitte wende dich an die Verwaltung.",
  },
  roles: {
    admin: "Verwaltung",
    approver: "Freigabe",
    coordinator: "Koordination",
    payroll: "Lohnbüro",
    employee: "Mitarbeiter",
  },
  weekdays: { mon: "Mo", tue: "Di", wed: "Mi", thu: "Do", fri: "Fr", sat: "Sa", sun: "So" },
  status: {
    present: "Anwesend",
    break: "In Pause",
    gone: "Gegangen",
    not_started: "Noch nicht da",
    absent: "Abwesend",
    day_off: "Frei",
    holiday: "Feiertag",
  },
  anomaly: {
    missing_clock_out: "Gehen fehlt",
    no_presence: "Keine Anwesenheit",
    foreign_terminal: "Fremdes Terminal",
    break_shortfall: "Pflichtpause zu kurz",
    break_report_short: "Kürzere Pause gemeldet",
    auto_break_applied: "Pflichtpause automatisch abgezogen",
    duplicate_ignored: "Doppelt gestempelt (ignoriert)",
    work_on_day_off: "Arbeit an freiem Tag",
  },
  punch_status: {
    valid: "Gezählt",
    duplicate: "Doppelt",
    rejected_foreign_terminal: "Fremdes Terminal",
    voided: "Storniert",
  },
  absence_type: {
    ferie: "Ferie (Urlaub)",
    permessi: "Permessi",
    rol: "ROL",
    sick: "Krankheit",
    injury: "Unfall",
    parental: "Elternzeit",
    training: "Schulung",
    other: "Sonstiges",
  },
  today: {
    eyebrow: "Heute",
    title: "Wer ist da?",
    description: "Live aus den Stempelungen aller Abteilungen.",
    present: "Anwesend",
    missing_break: "Pause fällig",
    anomalies: "Offene Anomalien",
    anomalies_hint: "letzte 31 Tage",
    unassigned: "Unbekannte Karten",
    list_title: "Mitarbeiter heute",
    worked: "Gearbeitet",
    break: "Pause",
    first_in: "Kommen",
    inbox_title: "Karten-Eingang",
    inbox_hint: "Stempelungen von Karten, die noch keinem Mitarbeiter zugeordnet sind.",
    inbox_empty: "Alle Karten sind zugeordnet.",
    assign: "Zuordnen",
    assign_title: "Karte zuordnen",
    assign_hint: "Alle wartenden Stempelungen dieser Karte werden danach automatisch nachverarbeitet.",
    taps: "{{count}} Stempelung(en)",
    reprocessed: "Karte zugeordnet, {{count}} Stempelung(en) nachverarbeitet.",
    reader: "Leser",
  },
  employees: {
    eyebrow: "Stammdaten",
    title: "Mitarbeiter",
    description: "Abteilung, Zeitplan-Vorlage, Karte und Zugang zur Mitarbeiter-App.",
    new: "Neuer Mitarbeiter",
    personnel_number: "Personalnummer",
    first_name: "Vorname",
    last_name: "Nachname",
    email: "E-Mail",
    entry_date: "Eintritt",
    exit_date: "Austritt",
    schedule: "Zeitplan",
    schedule_since: "seit {{date}}",
    change_schedule: "Zeitplan ändern",
    valid_from: "Gültig ab",
    card: "Karte",
    cards: "Karten",
    card_none: "Keine Karte",
    revoke: "Sperren",
    app_access: "Mitarbeiter-App",
    app_active: "Aktiv",
    app_none: "Kein Zugang",
    invite: "Einladen",
    invited: "Einladung verschickt",
    has_bonus: "Bonus hinterlegt",
    notes: "Notizen",
    empty: "Noch keine Mitarbeiter angelegt.",
    balance: "Zeitkonto",
    filter_department: "Abteilung",
  },
  times: {
    eyebrow: "Zeiten",
    title: "Stempelungen",
    description: "Tag für Tag, mit Pflichtpause, Soll und Differenz. Korrekturen werden protokolliert.",
    select_employee: "Mitarbeiter wählen",
    target: "Soll",
    worked: "Ist",
    break: "Pause",
    auto_break: "Autom. Pause",
    credit: "Gutschrift",
    delta: "Differenz",
    punches: "Stempelungen",
    intervals: "Arbeitsblöcke",
    add_punch: "Stempelung nachtragen",
    add_punch_hint: "Für vergessene Stempelungen. Zählt wie eine Stempelung am Leser.",
    void: "Stornieren",
    void_title: "Stempelung stornieren",
    manual: "Nachgetragen",
    break_report: "Pausen-Nachtrag",
    break_report_hint: "Tatsächlich genommene, aber nicht gestempelte Pause. Ersetzt den automatischen Abzug.",
    remove_break_report: "Nachtrag entfernen",
    acknowledge: "Als geklärt markieren",
    acknowledged: "Geklärt",
    no_punches: "Keine Stempelungen",
    day_open: "läuft",
    month_total: "Monat gesamt",
    empty: "Keine Tage in diesem Zeitraum.",
  },
  absences: {
    eyebrow: "Zeiten",
    title: "Abwesenheiten",
    description: "Ferie, Permessi, ROL, Krankheit. Die Gutschrift erfolgt auf das Tages-Soll. Anträge kommen mit Phase 2.",
    new: "Abwesenheit erfassen",
    type: "Art",
    period: "Zeitraum",
    full_day: "Ganzer Tag",
    minutes_per_day: "Minuten pro Tag",
    empty: "Keine Abwesenheiten in diesem Zeitraum.",
  },
  accounts: {
    eyebrow: "Zeiten",
    title: "Zeitkonten",
    description: "Saldo bis gestern: Tagesdifferenzen plus Korrekturen und Auszahlungen.",
    balance: "Saldo",
    adjustment: "Korrektur buchen",
    adjustment_hint: "Positive Minuten schreiben gut, negative belasten.",
    minutes: "Minuten",
    entries: "Buchungen",
    kind: {
      manual_adjustment: "Korrektur",
      overtime_payout: "Auszahlung",
      carry_over: "Übertrag",
    },
  },
  payroll: {
    eyebrow: "Lohn",
    title: "Monatsabschluss",
    description: "Monatsstunden fürs Lohnbüro und Überstunden zur Auszahlung.",
    days_worked: "Tage",
    open_anomalies: "Offen",
    payout: "Auszahlung",
    balance_end: "Saldo Monatsende",
    close: "Monat abschließen",
    close_title: "Monat {{month}} abschließen",
    close_hint: "Danach sind Stempelungen und Korrekturen dieses Monats gesperrt.",
    close_blocked: "{{count}} Tag(e) mit offenen Anomalien. Bitte klären oder mit Begründung abschließen.",
    override_reason: "Begründung für den Abschluss trotz offener Anomalien",
    closed: "Abgeschlossen",
    open: "Offen",
    reopen: "Wieder öffnen",
    reopen_title: "Monat wieder öffnen",
    export_hours: "Monatsstunden",
    export_overtime: "Überstunden",
    exported: "Export erstellt: {{file}}",
    payout_title: "Überstunden auszahlen",
    payout_hint: "Die Stunden werden zum Monatsletzten vom Zeitkonto abgebucht und erscheinen im Überstunden-Export.",
    payout_hours: "Stunden",
    month_not_over: "Der Monat ist noch nicht zu Ende.",
  },
  settings: {
    eyebrow: "Verwaltung",
    title: "Einstellungen",
    description: "Regeln, Zeitpläne, Abteilungen, Terminals und Zugänge — alles einstellbar, nichts fest im Code.",
    tabs: {
      rules: "Regeln",
      templates: "Zeitpläne",
      departments: "Abteilungen & Terminals",
      unifi: "UniFi Access",
      users: "Benutzer",
    },
    rules: {
      valid_from: "Gültig ab",
      valid_from_hint: "Frühere Tage rechnen weiter mit der alten Fassung.",
      breakThresholdMinutes: "Pflichtpause ab (Minuten Arbeit)",
      requiredBreakMinutes: "Dauer der Pflichtpause (Minuten)",
      minBreakSegmentMinutes: "Kürzeste anrechenbare Pause (Minuten)",
      duplicateWindowSeconds: "Doppel-Tipp-Sperre (Sekunden)",
      autoBreakDeduction: "Fehlende Pflichtpause beim Tagesabschluss abziehen",
      capAutoBreakAtThreshold: "Abzug höchstens bis zur Schwelle",
      breakReminderTime: "Erinnerung an die Pause um",
      dayCloseTime: "Tagesabschluss um",
      history: "Fassungen",
      saved: "Regeln gespeichert, {{count}} Tag(e) neu ausgewertet.",
    },
    templates: {
      new: "Neue Vorlage",
      name: "Name",
      description: "Beschreibung",
      weekly: "Woche",
    },
    departments: {
      new: "Neue Abteilung",
      name: "Name",
      terminals: "Terminals",
      new_terminal: "Neues Terminal",
      device_id: "UniFi-Leser-ID",
      location_id: "UniFi-Tür-ID",
      last_event: "Letzte Stempelung",
      never: "noch nie",
    },
    unifi: {
      intro: "Jede Kartenöffnung an einem UniFi-Access-Leser wird als signierter Webhook an optitime gemeldet.",
      webhook_url: "Webhook-Adresse",
      webhook_secret: "Webhook-Secret",
      api_url: "API-Adresse (Tunnel oder Portfreigabe)",
      api_url_hint: "z. B. https://unifi-api.betrieb.it — Port 12445 des Controllers, nur über HTTPS mit gültigem Zertifikat.",
      api_token: "API-Token",
      cf_id: "Cloudflare-Access Client-ID",
      cf_secret: "Cloudflare-Access Client-Secret",
      stored: "hinterlegt",
      missing: "fehlt",
      last_webhook: "Letzter Webhook",
      last_api: "Letzter API-Kontakt",
      last_error: "Letzter Fehler",
      test: "Verbindung testen",
      register: "Webhook registrieren",
      backfill: "Jetzt nachholen",
      devices: "Leser am Controller",
      users: "Benutzer am Controller",
      test_ok: "Verbindung steht, {{count}} Gerät(e) gefunden.",
      registered: "Webhook registriert.",
      backfilled: "{{fetched}} Ereignis(se) gelesen, {{processed}} neu verarbeitet.",
      replace_hint: "Leer lassen, um den hinterlegten Wert zu behalten.",
    },
    users: {
      invite: "Benutzer einladen",
      name: "Name",
      roles: "Rollen",
      link_employee: "Mit Mitarbeiter verknüpfen",
      deactivate: "Deaktivieren",
    },
  },
  me: {
    today: "Heute",
    week: "Woche",
    account: "Konto",
    settings: "Ich",
    clocked_in: "Eingestempelt",
    clocked_out: "Nicht eingestempelt",
    since: "seit {{time}}",
    worked_today: "Heute gearbeitet",
    break_taken: "Pause genommen",
    break_due: "Pflichtpause noch offen: {{minutes}} Min.",
    break_ok: "Pflichtpause erledigt",
    blocks: "Heutige Blöcke",
    balance: "Zeitkonto",
    balance_hint: "Stand bis gestern",
    push_title: "Benachrichtigungen",
    push_enable: "Benachrichtigungen aktivieren",
    push_enabled: "Benachrichtigungen sind aktiv.",
    push_unsupported: "Dieser Browser unterstützt keine Benachrichtigungen.",
    push_ios_hint: "Auf dem iPhone: zuerst über „Teilen → Zum Home-Bildschirm“ installieren, dann hier aktivieren.",
    push_denied: "Benachrichtigungen sind im Browser blockiert.",
    install_hint: "Tipp: Füge optitime zum Home-Bildschirm hinzu.",
    no_employee: "Dein Zugang ist noch mit keinem Mitarbeiter verknüpft.",
    requests_soon: "Anträge (Pausen-Nachtrag, Korrektur, Urlaub) kommen mit Phase 2.",
  },
  errors: {
    generic: "Das hat nicht geklappt.",
    period_closed: "Der Monat ist bereits abgeschlossen.",
    forbidden: "Dafür fehlt dir die Berechtigung.",
    absence_overlap: "In diesem Zeitraum gibt es schon eine Abwesenheit.",
    credential_already_assigned: "Diese Karte ist bereits einem Mitarbeiter zugeordnet.",
    employee_already_linked: "Dieser Mitarbeiter hat bereits einen Zugang.",
    invalid_input: "Bitte die Eingaben prüfen.",
    network_error: "Keine Verbindung zum Server.",
    future_punch: "Stempelungen in der Zukunft sind nicht möglich.",
    open_anomalies: "Es gibt noch offene Anomalien.",
    month_not_over: "Der Monat ist noch nicht zu Ende.",
    request_id: "Support-Kennung",
  },
};

export type Messages = typeof de;
